import { jsxs as d, jsx as t } from "react/jsx-runtime";
import f from "next/legacy/image";
import I from "next/link";
import g from "@mui/material/Box";
import C from "@mui/material/Card";
import v from "@mui/material/CardContent";
import p from "@mui/material/Grid";
import h from "@mui/material/Typography";
import { makeStyles as w } from "tss-react/mui";
import { infoBoxes as o } from "@lumirental/lumi-web-shared/lib/constants/IR/content";
import { useConfigContext as b } from "@lumirental/lumi-web-shared/lib/contexts/Config.context";
import { useLanguageContext as N } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import x from "@lumirental/lumi-web-shared/lib/utils/cdnLinks/getPublicCDNLink";
import L from "../../../../../common/Button/Button.js";
import j from "./InfoBlocks.style.js";
const y = w()(j), k = ({ data: a }) => {
  const { classes: r } = y(), { language: n, isRtl: u } = N(), { appEnv: l } = b(), { bgImg: c, title: s, subtitle: i, action: e } = a, m = `${r.arrowBtn} ${u ? "rtl" : ""}`;
  return /* @__PURE__ */ d(C, { className: r.card, children: [
    /* @__PURE__ */ t(g, { className: r.bgImg, children: /* @__PURE__ */ t(
      f,
      {
        alt: "Lumi Quick Links Img",
        src: x(c, l),
        layout: "fill",
        objectFit: "cover",
        quality: 100,
        priority: !0
      }
    ) }),
    /* @__PURE__ */ t(g, { className: r.overlay }),
    /* @__PURE__ */ d(v, { className: r.content, children: [
      /* @__PURE__ */ d(g, { className: r.titleWrapper, sx: { marginBottom: 1 }, children: [
        s && /* @__PURE__ */ t(h, { variant: "h3", className: r.title, children: s[n] }),
        e && /* @__PURE__ */ t(I, { href: e.link, legacyBehavior: !0, children: /* @__PURE__ */ t(
          L,
          {
            dataTestid: "quickLinkArrowIcon",
            variation: "text",
            size: "small",
            sx: { padding: 0 },
            className: m,
            children: /* @__PURE__ */ t(
              f,
              {
                alt: "Quick Links Arrow",
                src: x(
                  "/images/png/arrow-right-white.png",
                  l
                ),
                width: 24,
                height: 24
              }
            )
          }
        ) })
      ] }),
      i && /* @__PURE__ */ t(h, { variant: "subheading", className: r.subtitle, children: i[n] })
    ] })
  ] });
}, q = () => {
  var c, s, i, e;
  const { classes: a } = y(), { language: r } = N(), n = (c = o) == null ? void 0 : c.list.slice(0, 1)[0], u = (s = o) == null ? void 0 : s.list.slice(1), { title: l } = o;
  return /* @__PURE__ */ d(
    p,
    {
      id: "quick-links",
      container: !0,
      className: a.wrapper,
      spacing: { xs: 2, sm: 5 },
      sx: { paddingBottom: 5 },
      children: [
        o.title && /* @__PURE__ */ t(p, { item: !0, xs: 12, children: /* @__PURE__ */ t(h, { variant: "h2", className: a.sectionTitle, children: l[r] }) }),
        /* @__PURE__ */ t(p, { item: !0, xs: 12, sm: 8, children: /* @__PURE__ */ t(k, { data: n }) }),
        (e = (i = o) == null ? void 0 : i.list) != null && e.length ? u.map((m) => {
          const { id: B } = m;
          return /* @__PURE__ */ t(p, { item: !0, xs: 6, sm: 4, children: /* @__PURE__ */ t(k, { data: m }) }, B);
        }) : null
      ]
    }
  );
}, K = q;
export {
  K as default
};
